import styled from "styled-components";
import { Checkbox } from "antd";

export const Search = styled.input`
  width: 100%;
  padding: 16px 16px 16px 16px;
  font-size: 14px;
  background: transparent;
  border: solid 1px #eeeeee;
  outline: none;
  border-style: none;
`;

export const ReportCheckbox = styled(Checkbox)`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: transparent;
    border-color: black;
    &:after {
      border-color: black;
    }
  }
`;
